import { closestCenter, pointerWithin, rectIntersection, type CollisionDetection } from "@dnd-kit/core";

/**
 * The board's collision cascade: pointer → rect intersection → closest centre.
 *
 * Adopted from bd-admin, whose comment documents the failure this fixes: a single
 * corner-based strategy drifts away from the cursor on tall cards and at cell edges, so the
 * preview lights up a cell the pointer is not in. `pointerWithin` is exactly right whenever
 * the cursor is over a cell, which is almost always; `rectIntersection` covers the moment
 * the cursor leaves the grid while the dragged card still overlaps a cell; `closestCenter`
 * is the last resort at the grid's margins, where a drop must still resolve to *something*
 * rather than silently do nothing.
 *
 * Order matters and is the whole point — each strategy is only consulted when the one above
 * it found nothing, so the cheapest and most faithful answer always wins.
 */
export const boardCollisionDetection: CollisionDetection = (args) => {
  const pointerCollisions = pointerWithin(args);
  if (pointerCollisions.length > 0) return pointerCollisions;

  const rectCollisions = rectIntersection(args);
  if (rectCollisions.length > 0) return rectCollisions;

  return closestCenter(args);
};
